// extracted by mini-css-extract-plugin
module.exports = {"CancelButton":"ConfirmModal_CancelButton__LOhDD","AcceptButton":"ConfirmModal_AcceptButton__PVrMA"};